import api from './api';

// バックエンドが返す実効単価データ
export interface EffectiveUnitPrice {
  source: 'member' | 'category';
  Effective_Date: string | null; // member のとき適用開始日 / category のとき null
  Weekday_Unit_Price: number;
  Holiday_Unit_Price: number;
}

const memberUnitPriceService = {
  /**
   * 社員（T_010_Member）の「その日報の日付」時点で有効な単価を解決する。
   * @param memberId 社員ID
   * @param date     日報の日付（必ず YYYY-MM-DD。今日ではない）
   * 個人別単価が無い社員はバック側で自動的にカテゴリ単価へフォールバックされる。
   */
  getEffective: async (memberId: number, date: string): Promise<EffectiveUnitPrice> => {
    const res = await api.get(`/member-unit-price/member/${memberId}/effective`, {
      params: { date },
    });
    return res.data.data; // { source, Effective_Date, Weekday_Unit_Price, Holiday_Unit_Price }
  },
};

export default memberUnitPriceService;
